import React, { FC, Ref } from 'react';
import { kebabCase } from 'lodash';
import styled from 'styled-components';
import { globalTheme } from '@cld/component-theme';
import { Icon, Icons } from '@cld/icon';
import TextField from '@cld/text-field';
import { typography } from '@cld/typography';

const Root = styled.div`
  width: 100%;
`;

const Label = styled.div`
  ${typography.xs.regular};
  display: block;
  padding: ${globalTheme.spacing.xs} 0;
`;

export interface FormRowProps {
  label: string;
  inputType: 'text' | 'password';
  iconName: Icons;
  value: string;
  onChange: (value: string) => void;
  inputRef: Ref<HTMLInputElement>;
  onEnter: () => void;
  fieldId: string;
}

export const FormRow: FC<FormRowProps> = ({ label, inputType, iconName, value, onChange, inputRef, onEnter, fieldId }) => (
  <Root>
    <Label>{label}</Label>
    <TextField
      size="md"
      type={inputType}
      leadingDecoration={<Icon name={iconName} size="sm" />}
      value={value}
      onChange={onChange}
      inputRef={inputRef}
      data-test={`login-${kebabCase(fieldId)}-textfield-base`}
      inputProps={{
        onKeyDown: (event) => event.key === 'Enter' && onEnter(),
        'data-test': `login-${kebabCase(fieldId)}-textfield`
      }}
    />
  </Root>
);
